// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__16EAk","name":"Header_name__zivnk","birthday":"Header_birthday__T7Yuh","skeleton":"Header_skeleton__q88ES"};